const ones = [
  '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
  'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
  'Seventeen', 'Eighteen', 'Nineteen'
];

const tens = [
  '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
];

// const scales = ['', 'Thousand', 'Lakh', 'Crore'];

function convertLessThanThousand(num: number): string {
  if (num === 0) return '';
  if (num < 20) return ones[num];
  if (num < 100) {
    return tens[Math.floor(num / 10)] + (num % 10 !== 0 ? ' ' + ones[num % 10] : '');
  }
  return ones[Math.floor(num / 100)] + ' Hundred' + (num % 100 !== 0 ? ' ' + convertLessThanThousand(num % 100) : '');
}

export function numberToWords(num: number): string {
  if (num === 0) return 'Zero';

  // Handle decimals
  const parts = num.toString().split('.');
  const integerPart = parseInt(parts[0]);
  const decimalPart = parts[1] ? parseInt(parts[1].substring(0, 2).padEnd(2, '0')) : 0;

  let words = '';

  if (integerPart === 0) {
    words = 'Zero';
  } else {
    // Indian numbering system: ones, thousands, lakhs, crores
    const crores = Math.floor(integerPart / 10000000);
    const lakhs = Math.floor((integerPart % 10000000) / 100000);
    const thousands = Math.floor((integerPart % 100000) / 1000);
    const hundreds = integerPart % 1000;

    const parts: string[] = [];

    if (crores > 0) {
      parts.push(convertLessThanThousand(crores) + ' Crore');
    }
    if (lakhs > 0) {
      parts.push(convertLessThanThousand(lakhs) + ' Lakh');
    }
    if (thousands > 0) {
      parts.push(convertLessThanThousand(thousands) + ' Thousand');
    }
    if (hundreds > 0) {
      parts.push(convertLessThanThousand(hundreds));
    }

    words = parts.join(' ');
  }

  if (decimalPart > 0) {
    words += ' and ' + convertLessThanThousand(decimalPart) + ' Paise';
  }

  return 'Rupees ' + words + ' Only';
}

export function formatCurrency(num: number): string {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
}
